import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Message } from "element-ui";
import "./assets/css/newUi.scss"
import "./assets/iconfont/icon/iconfont.css"; //引入阿里巴巴矢量图标库
import "./assets/iconfont/icon/iconfont.js";
import EChartsVue from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
Vue.component("v-chart", EChartsVue);
import BaseTable from "@/components/BaseTable/Index.vue";
Vue.component('BaseTable', BaseTable)
import DeviceFormDialog from "@/components/DeviceFormDialog/Index.vue";
Vue.component('DeviceFormDialog', DeviceFormDialog)
import AmapMarker from "@/components/AmapMarker/Index.vue";
Vue.component('AmapMarker', AmapMarker)
import RH_BIM_MODEL from "@/components/RH_BIM_MODEL/RH_BIM_MODEL.vue";
Vue.component('RH_BIM_MODEL', RH_BIM_MODEL)
import ImageAnnotator from "@/components/ImageAnnotator/ImageAnnotator.vue";
Vue.component('ImageAnnotator', ImageAnnotator)
//默认点击空白处不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI);
import animated from "animate.css";
Vue.use(animated);
import 'animate.css'; // 全局引入 Animate.css 样式
import { NoticeBar } from 'vant';
Vue.use(NoticeBar);


import axios from "axios";
Vue.prototype.axios = axios;

Vue.config.productionTip = false;

// 权限按钮配置
import permission from "@/directive/permission";
Vue.directive("permission", permission);
// dataV
import dataV from "@jiaminghi/data-view";
Vue.use(dataV);

//  es6 => es5

import "babel-polyfill";
import Es6Promise from "es6-promise";
require("es6-promise").polyfill();
Es6Promise.polyfill();
//引入Ztree
import Ztree from '@/components/componentsTree'
//注册为全局组件
Vue.component('Ztree', Ztree)
// 引入echarts
import * as echarts from "echarts";
import "echarts/theme/macarons.js";
Vue.prototype.$echarts = echarts;
import Pdfh5 from "pdfh5";
Vue.prototype.$Pdfh5 = Pdfh5;

import china from "echarts/map/json/china.json";
echarts.registerMap("china", china);
import "echarts-wordcloud/dist/echarts-wordcloud.min.js";

//萤石云
import EZUIKit from 'ezuikit-js';
Vue.use(EZUIKit);
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

import htmlToPdf from "./components/utils/htmlToPdf";
Vue.use(htmlToPdf);

import { format } from "@/tools/tool";

import myplugin from "@/plugin/copyVuex";

import "@/assets/font-family/font.css"
// import '@/tools/init.js'

// 路由传参加密
const UrlEncode = {
  // //加密
  // encode(str) {
  //   return btoa(
  //     encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(
  //       match,
  //       p1
  //     ) {
  //       return String.fromCharCode("0x" + p1);
  //     })
  //   );
  // },
  // //解密
  // decode(str) {
  //   // Going backwards: from bytestream, to percent-encoding, to original string.
  //   return decodeURIComponent(
  //     atob(str)
  //       .split("")
  //       .map(function (c) {
  //         return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  //       })
  //       .join("")
  //   );
  // },
  encode(str) {
    // 对字符串进行编码
    var encode = encodeURI(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
  },
  decode(base64) {
    // 对base64转编码
    var decode = atob(base64);
    // 编码转字符串
    var str = decodeURI(decode);
    return str;
  }
};
Vue.prototype.$UrlEncode = UrlEncode;

Vue.use(myplugin);
Date.prototype.format = format;


function checkFile(fileValue, type) {
  if (fileValue) {
    var index = fileValue.name.indexOf(".");
    let fileValueSuffix = fileValue.name.substring(index);
    if (type == "video") {
      if (!/(.*)\.(mp4|rmvb|avi|ts)$/.test(fileValueSuffix)) {
        Message.error("文件格式错误请选择视频！")
        return false;
      } else {
        return true;
      }
    }
    if (type == "image") {
      if (!/(.*)\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(fileValueSuffix)) {
        Message.error("文件格式错误请选择图片！")
        return false;
      } else {
        return true;
      }
    }
  } else {
    Message.error("系统出错！")
    return false;
  }
}

Vue.prototype.$checkFile = checkFile;



new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
